export const JSON_CONTENT_TYPE = 'application/json';

export enum ApiRequestHeaders {
  AUTHORIZATION = 'Authorization',
  HQO_BUILDING_UUID = 'hqo-building-uuid',
  ALT_BUILDING_UUID = 'alt-building-uuid',
  CONTENT_TYPE = 'Content-Type',
}
